import { useCallback, useMemo } from 'react'
import { generatePath, Link, useParams } from 'react-router-dom'
import { Button, Menu, Space } from 'antd'
import * as Icons from '@ant-design/icons'

import { Queries, useApiQuery } from 'admin/lib/Api'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { GetPageNames } from 'admin/lib/GetPageNames'
import { Layout } from 'admin/lib/Layouts'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'

import { ProjectList } from './ProjectList'

export function Projects() {
  const { accountId } = useParams()
  const accounts = Queries.useAccounts()

  const accountDropdownOptions = useMemo(() => {
    if (accounts.data) {
      const items = []
      accounts.data.forEach(item => {
        items.push({
          key: item.accountId,
          label: (
            <a
              href={generatePath(ROUTES.PROJECTS.LIST, {
                accountId: item.accountId
              })}
            >
              {item.name}
            </a>
          )
        })
      })

      return (
        <Menu style={{ maxHeight: '400px', overflow: 'auto' }} items={items} />
      )
    }
  }, [accounts.data])

  const projects = useApiQuery(
    useCallback(
      api => {
        return api.listProjects(accountId)
      },
      [accountId]
    )
  )

  const pageNames = GetPageNames(accountId)

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem
                    href={generatePath(ROUTES.ACCOUNTS.LIST)}
                  >
                    Accounts
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem
                    loading={!pageNames.data}
                    overlay={accountDropdownOptions}
                  >
                    {pageNames.data && pageNames.data.accountName}
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: 'Projects'
              }
            ]}
          />

          <Space>
            <Link
              to={generatePath(ROUTES.PROJECTS.NEW, {
                accountId: accountId
              })}
            >
              <Button type="primary" icon={<Icons.FormOutlined />}>
                New
              </Button>
            </Link>
          </Space>
        </>
      }
    >
      {!projects.loaded && <ScreenSpin />}

      {projects.error && (
        <div>
          Something went wrong:{' '}
          {String(projects.error.response?.data ?? projects.error)}
        </div>
      )}

      {projects.loaded && projects.data && (
        <ProjectList projects={projects.data} accountId={accountId} />
      )}
    </Layout>
  )
}
